// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServiceCategories_AtributosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/service_categories/atributos/{category_id}
 *
 * Returns the attribute bindings (with nested options for `select` types)
 * configured for the given service category, used by the add-item wizard.
 * Mirrors So_category_attributes_model::listByCategory(). Legacy `dados`
 * shape is a list, so getDados() returns the array directly.
 */
import type { Item_attributes_CategoryBindingRow } from './Item_attributes_CategoryBindingRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServiceCategories_AtributosResponseDados = Item_attributes_CategoryBindingRow[];

export type ServiceCategories_AtributosResponse = ApiResponse<ServiceCategories_AtributosResponseDados>;

registerResponseContract('ServiceCategories_AtributosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_category_attribute_id:             { type: 'number',  required: true },
      so_category_attribute_category_id:    { type: 'number',  required: true },
      so_category_attribute_attribute_id:   { type: 'number',  required: true },
      so_category_attribute_required:       { type: 'number',  required: true },
      so_category_attribute_display_order:  { type: 'number',  required: true },
      so_category_attribute_created_at:     { type: 'string',  required: true },
      so_item_attribute_name:               { type: 'string',  required: true },
      so_item_attribute_type:               { type: 'string',  required: true },
      so_category_attribute_is_description: { type: 'number',  required: false },
      options: {
        type: 'array',
        required: false,
        items: {
          so_item_attribute_option_id:            { type: 'number',  required: true },
          so_item_attribute_option_attribute_id:  { type: 'number',  required: true },
          so_item_attribute_option_value:         { type: 'string',  required: true },
          so_item_attribute_option_icon_svg:      { type: 'string',  required: false },
          so_item_attribute_option_display_order: { type: 'number',  required: true },
          so_item_attribute_option_active:        { type: 'number',  required: true },
          so_item_attribute_option_created_at:    { type: 'string',  required: true },
        },
      },
    },
  },
})
